import endpoints from "../config/endpoints";
import api from "../config/axios";

export const GetAllProductAttributesWithValues = async (params) => {
    let query = "";

    if (params !== undefined) {
        let queryParts = [];
        Object.keys(params).forEach(key => {
            const value = params[key];
            if (Array.isArray(value)) {
                value.forEach(val => {
                    queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
                });
            } else if (value !== null && value !== undefined) {
                queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            }
        });
        query = queryParts.join('&');
    }
    
    const url = `${endpoints.Attributes.GetAllProductAttributesWithValues}?${query}`;

    const response = await api.get(url);

    // Return the full response with pagination metadata
    return {
        data: response.data.data || [],
        pagination: {
            pageIndex: response.data.pageIndex,
            pageSize: response.data.pageSize,
            totalRecord: response.data.totalRecord,
        },
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
};

export const GetAllAttributes = async () => {
    const response = await api.get(endpoints.Attributes.GetAllAttributes);
    return {
        data: response.data.data || [],
        pagination: {
            pageIndex: response.data.pageIndex,
            pageSize: response.data.pageSize,
            totalRecord: response.data.totalRecord,
        },
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
}

export const getAttributes = GetAllProductAttributesWithValues;

export const AddAttribute = async (formData) => {
    const response = await api.post(endpoints.Attributes.AddAttribute, formData);
    return {
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
};

export const UpdateAttribute = async (id, formData) => {
    const response = await api.put(`${endpoints.Attributes.UpdateAttribute}?id=${id}`, formData);
    return {
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
};

export const DeleteAttribute = async (id) => {
    const response = await api.delete(`${endpoints.Attributes.DeleteAttribute}?id=${id}`);
    return {
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
};

const attributeService = {
    getAttributes,
    GetAllAttributes,
    AddAttribute,
    UpdateAttribute,
    DeleteAttribute,
};

export default attributeService;
